'use client'

import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {memo} from 'react'

export type ChasingZeroGameProps = SliceComponentProps<Content.ChasingZeroGameSlice>

const ChasingZeroGame = ({slice}: ChasingZeroGameProps): JSX.Element => (
  <section data-slice-type={slice.slice_type} data-slice-variation={slice.variation} className="fixed inset-0 z-50">
    <iframe
      src="/games/chasing-zero/index.html"
      className="absolute inset-0 size-full border-0"
      title="Chasing Zero Game"
      allowFullScreen
    />
  </section>
)

export default memo(ChasingZeroGame)
